import { Select, theme } from 'antd'
import { t } from 'i18next'
import { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { workspaceDocumentSetAllOwnersStatus } from '../../../constants/constants'
import { useUsers, useWorkspaceDetails } from '../../../hooks'
import { SelectOption } from '../../../types/generalTypes'
const { useToken } = theme

interface SelectConformityDocumentOwnerProps {
  defaultValue?: string
  value?: string
  onChange?: (value: string | undefined) => void
  loading?: boolean
  fetchData?: boolean
}

const SelectConformityDocumentOwner = ({
  defaultValue,
  value,
  onChange,
  loading,
  fetchData = false,
}: SelectConformityDocumentOwnerProps) => {
  const { workspaceId } = useParams()
  const { token } = useToken()
  const { selectedWorkspace } = useWorkspaceDetails({
    workspaceId,
    preventFetch: true,
  })
  const [selectedValue, setSelectedValue] = useState<string | undefined>(
    defaultValue
  )
  const { findUser } = useUsers({})

  const options: SelectOption[] = useMemo(() => {
    if (!selectedWorkspace?.config?.conformityChecksConfig?.documents?.length) {
      return []
    }

    const ownerIds: string[] =
      selectedWorkspace?.config?.conformityChecksConfig?.documents
        .map((document) => document.ownerId)
        .filter((id): id is string => id !== undefined) || []

    const uniqueOwnerIds: string[] = Array.from(new Set(ownerIds))

    const options = uniqueOwnerIds.map((ownerId) => {
      const user = findUser(ownerId)
      return {
        label: user?.displayName || ownerId,
        value: ownerId,
      }
    })
    return options || []
  }, [selectedWorkspace, findUser])

  useEffect(() => {
    if (value) {
      setSelectedValue(value)
    }
  }, [value])

  const handleChange = (value: string) => {
    setSelectedValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  const allOptions = useMemo(
    () => [
      {
        label: t('workspaceDetailsPage.selectDocumentSetOwner.all'),
        value: workspaceDocumentSetAllOwnersStatus,
      },
      ...options,
    ],
    [options]
  )

  return (
    <Select
      className="select-workspace-filter"
      style={{ minWidth: 200, color: token.colorPrimary }}
      onChange={handleChange}
      value={selectedValue}
      options={allOptions}
      placeholder={t('workspaceDetailsPage.selectDocumentSetOwner.all')}
      loading={loading}
      variant="borderless"
    />
  )
}

export default SelectConformityDocumentOwner
